import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import ExampleItemView from "./ExampleItemView";

export default class BottomHudView extends AbstractView {

    constructor(target, languagePack) {        
        super(target);
        this._languagePack = languagePack;
        this._target.findLabelTextfield.text = this.getText("hud.findLabel");
        
        this._sampleView = new ExampleItemView(this._target.bird);
        this._sampleViewOrigY = this._target.bird.y;
        this._sampleViewOrigScaleX = this._target.bird.scaleX;

        this._handleDoneClick = this._handleDoneClick.bind(this);
        this._buttonSubmit = this.createButton(this._target.button, this._handleDoneClick, this.getText("hud.buttonSubmit"));
        this._buttonSubmit.setEnabled(false);
        this._buttonFinishPractice = this.createButton(this._target.continueButton, this._handleDoneClick, this.getText("hud.buttonFinishPractice"));
        this._buttonFinishPractice.setVisible(false);

        this._centerVertically(this._target.findLabelTextfield, this._target);

        CacheUtil.cache(this._target.findLabelTextfield);
    }

    enableSubmit(bool) {
        this._buttonSubmit.setEnabled(bool);
    }

    showFinishPractice(bool) {
        this._buttonFinishPractice.setVisible(bool);
        this._buttonSubmit.setVisible(!bool);
    }

    setSample(skin, flipped) {
        this._sampleView.content = skin;
        this._sampleView.target.scaleX = this._sampleViewOrigScaleX * (flipped ? -1 : 1);
    }

    crossFadeSample(skin, flipped, duration, delayBetween = 0) {
        const target = this._sampleView.target;
        const origY = this._sampleViewOrigY;
        createjs.Tween.get(target)
            .to({ alpha: 0, y: origY + 100 }, duration / 2, createjs.Ease.quadIn)
            .call(_ => {
                target.y = origY - 100;
                this.setSample(skin, flipped);
            })
            .wait(delayBetween)
            .to({ alpha: 1, y: origY }, duration / 2, createjs.Ease.quadOut);
    }

    _centerVertically(item, container) {
        const itemBounds = item.getBounds();
        const containerBounds = container.getBounds();
        if (itemBounds) {
            const y = containerBounds.y + (containerBounds.height - itemBounds.height) / 2;
            item.y = y;
        }
    }


    _handleDoneClick() {
        this.dispatchEvent(BottomHudView.SUBMIT);
    }
}

BottomHudView.SUBMIT = "BottomHudView.SUBMIT";

function padTime(str) {
    return ("0" + str).substr(-2);
}